import type React from 'react'
import useFeatureFlags from '../../../../hooks/useFeatureFlags'
import HomeSettingsScreen from './HomeSettingsScreen'

interface HomeSettingsProps {
  hasRosteringAccessControlSettings?: boolean
}

const HomeSettingsWrapper = () => {
  const flags = useFeatureFlags({
    flagNames: ['rostering_access_control_settings']
  })?.data

  const flagsRosteringAccessControlSettingsEnabled =
    flags?.rostering_access_control_settings?.enabled

  const HomeSettingsWithProps =
    HomeSettingsScreen as React.ComponentType<HomeSettingsProps>

  return (
    <HomeSettingsWithProps
      hasRosteringAccessControlSettings={
        flagsRosteringAccessControlSettingsEnabled
      }
    />
  )
}

export default HomeSettingsWrapper
